import React, { useState,useMemo ,useEffect }from "react";
import { useNavigate, useLocation } from "react-router-dom";
import InfoTabs from "../components/common/InfoTabs";
import { useDispatch ,useSelector} from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import {
    Container,
    Typography,
    Box,
    Slider,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    useTheme,
    Grid,
    Button,
    darken,
    useMediaQuery, TextField, InputAdornment, IconButton,
} from "@mui/material";
import Image from "../components/common/Image";
import { useTranslation } from "react-i18next";
import AccordionComponent from "../components/common/Accordion";
import { openModal, closeModal } from "../features/slices/modalSlice";
import * as Constant from "../features/constant";
import CopiedTooltip from "../components/common/CopiedTooltip";
import Income from "../components/referral/Income";
import Records from "../components/referral/Records";
import InviteeList from "../components/referral/InviteeList";
import { selectCurrentToken } from "../features/slices/authSlice";
import { useGetShareLinkQuery } from "../features/api/userApiSlice";
import { useGetReferralPageQuery } from "../features/api/homeApiSlice";
import dayjs from 'dayjs';
import SocialMediaButton from "../components/common/SocialMediaButton";

const Referral = () => {

    const { t } = useTranslation();
    const location = useLocation();
    const [selectedTab, setSelectedTab] = useState(location.state?.initialTab ?? 0);
    const navigate = useNavigate();
    const theme = useTheme();
    const mobileView = useMediaQuery(theme.breakpoints.down("sm"));
    const isLoggedIn = useSelector(selectCurrentToken);
    const [inviteCount, setInviteCount] = useState(1);
    const [referralRankings, setReferralRankings] = useState();
    const defaultShareMessage = "Come join and win big!";
    const isLightTheme = process.env.REACT_APP_IS_LIGHT_THEME;

    const { data, isSuccess } = useGetReferralPageQuery();

      const sections = [
    { id: "overview", label:t("referral.overview") },
    // temporary hide rewards until have more details
    //{ id: "rewards", label: "Rewards" },
    { id: "income", label: t("referral.income") ,component : <Income/> },
    { id: "records", label: t("referral.records"),component : <Records/>  },
    { id: "inviteelist", label: t("referral.inviteelist") , component: <InviteeList/>},
    ];

      const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

    const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    scrollToSection(sections[newValue].id);
  };

    const {
    data: shareLink,
    isLoading: isShareLinkLoading,
    isError: isShareLinkError,
    isSuccess: isShareLinkSuccess,
    error: shareLinkError,
  } = useGetShareLinkQuery();

    useEffect(() => {
    if (isSuccess && data) {
      setReferralRankings(data);
    }
  }, [isSuccess, data]);

    const boxStyle = {
        width: '200px',
        height: '80px',
        backgroundImage: 'url(/assets/img/yellow_big.png)',
        backgroundSize: '100% 100%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 1,
        textAlign: 'center',
    };

    const boxReward = {
        width: '100%',
        height: '80px',
        backgroundColor: 'lightgrey',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'left',
        alignItems: 'left',
        margin: 1,
        textAlign: 'left',
        borderRadius: '10px',
    };

    const RewardBox = ({ title, baseAmount, basePeople, dailyIncrement, peopleIncrement, imgSrc }) => {
        const today = dayjs();
        const startDate = dayjs('2025-06-01'); 

        const daysElapsed = today.diff(startDate, 'day');

        const amount = useMemo(() => baseAmount + (dailyIncrement * daysElapsed), [daysElapsed]);
        const people = useMemo(() => basePeople + (peopleIncrement * daysElapsed), [daysElapsed]);

        return (
            <Box sx={{ justifyContent: 'left', margin: 0.5 }}>
            <Box sx={boxReward}>
                <Box component="img" src={imgSrc} sx={{ width: 60, height: 60, padding: '10px', margin: '10px' }} />
                <Box sx={textContainer}>
                <Typography sx={{ fontSize: '14px', color: '#000000', fontWeight: 'bold', paddingTop: '5px' }}>
                    {title}
                </Typography>
                <Typography sx={{ fontSize: '20px', color: theme.palette.secondary.accent, fontWeight: 'bold' }}>
                    {process.env.REACT_APP_CURRENCY_CODE} {amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                </Typography>
                <Typography sx={{ fontSize: '12px', color: '#000000' }}>
                    {people.toLocaleString()} {t("referral.people")}
                </Typography>
                </Box>
            </Box>
            </Box>
        );
    };

    const textContainer = {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '10px'
    };

    const generateRandomId = () => {
        const chars = "abcdefghijklmnopqrstuvwxyz0123456789";
        let suffix = "";
        for (let i = 0; i < 3; i++) {
            suffix += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return "*****" + suffix;
        };

        const generateRandomAmount = () => {
        const amount = (Math.random() * 5).toFixed(2);
        return `${process.env.REACT_APP_CURRENCY_CODE} ${amount}`;
        };

        const [rewards, setRewards] = React.useState(() =>
        Array(4)
            .fill(0)
            .map(() => ({ id: generateRandomId(), amount: generateRandomAmount() }))
        );

        React.useEffect(() => {
        const interval = setInterval(() => {
            setRewards(
            Array(4)
                .fill(0)
                .map(() => ({ id: generateRandomId(), amount: generateRandomAmount() }))
            );
        }, 6000);

        return () => clearInterval(interval);
        }, []);

        const FlippingBox = React.memo(({ entry }: { entry: any }) => {
        return (
            <motion.div
            key={entry.id}
            initial={{ rotateY: 90, opacity: 0 }}
            animate={{ rotateY: 0, opacity: 1 }}
            exit={{ rotateY: -90, opacity: 0 }}
            transition={{ duration: 0.5 }}
            style={{
                perspective: 1000,
                marginBottom: "10px",
            }}
            >
            <Box
                sx={{
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                borderRadius: "30px",
                display: "flex",
                justifyContent: "space-between",
                padding: "10px 20px",
                color: "#000",
                }}
            >
                <Typography fontWeight="bold">{entry.id}</Typography>
                <Typography>{entry.amount}</Typography>
            </Box>
            </motion.div>
        );
        });

        const rewardList = React.useMemo(() => {
            return rewards.map((entry) => (
                <FlippingBox key={entry.id} entry={entry} />
            ));
        }, [rewards]);

	return (
  <Container>
   
      <Box sx={{
        display: {
        xs: 'block',  // mobile
        md: 'flex',   // desktop
        },
         }} >
        <Box sx={{     
            minWidth: { xs: '100%', sm: 200 }, 
             maxWidth: { xs: '100%', sm: 600 }, 
             mr: { xs: 0, sm: 3 },
             backgroundColor: "transparent",   }}>
            {isLoggedIn ? (
            <InfoTabs
                sections={sections}
                selectedTab={selectedTab}
                handleTabChange={handleTabChange}
            />
            ) : null}
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          {selectedTab === 0 ? (
        <>
        <Box>
            {isLoggedIn && (
            <>
            
                <Typography fontWeight="bold" sx={{ color: isLightTheme ? "black" : "white" }} paddingTop={"30px"} textAlign={"center"}>
                {t("referral.invite")}
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', margin: 1}}>
                <Box sx={{ display: 'flex',  margin: 1 , justifyContent:'center' }}>
                    <Box sx={boxStyle}>
                    <Typography sx={{ marginTop: '10px', fontSize: '12px', color: isLightTheme? "black": "white", fontWeight: 'bold' }}>
                        {t("referral.yesterdayreferral")}
                    </Typography>
                    <Typography sx={{ color: isLightTheme? "black": "white", fontWeight: 'bold' }}>{`${process.env.REACT_APP_CURRENCY_CODE} 0.00`}</Typography>
                    </Box>
                    <Box sx={boxStyle}>
                    <Typography sx={{ marginTop: '10px', fontSize: '12px', color: isLightTheme? "black": "white", fontWeight: 'bold' }}>
                        {t("referral.yesterdayteam")}
                    </Typography>
                    <Typography sx={{ color: isLightTheme? "black": "white", fontWeight: 'bold' }}>{`${process.env.REACT_APP_CURRENCY_CODE} 0.00`}</Typography>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex',  margin: 1, justifyContent:'center'  }}>
                    <Box sx={boxStyle}>
                    <Typography sx={{ marginTop: '20px', fontSize: '12px', color: isLightTheme? "black": "white", fontWeight: 'bold' }}>
                        {t("referral.yesterdayregister")}
                    </Typography>
                    <Typography sx={{ color: isLightTheme? "black": "white", fontWeight: 'bold' }}>0</Typography>
                    </Box>
                    <Box sx={boxStyle}>
                    <Typography sx={{ marginTop: '10px', fontSize: '12px', color: isLightTheme? "black": "white", fontWeight: 'bold' }}>
                        {t("referral.yesterdayteam")}
                    </Typography>
                    <Typography sx={{ color: isLightTheme? "black": "white", fontWeight: 'bold' }}>{`${process.env.REACT_APP_CURRENCY_CODE} 0.00`}</Typography>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex',  margin: 1 , justifyContent:'center' }}>
                    <Box sx={boxStyle}>
                    <Typography sx={{ marginTop: '10px', fontSize: '12px', color: isLightTheme? "black": "white", fontWeight: 'bold' }}>
                        {t("referral.yesterdayactive")}
                    </Typography>
                    <Typography sx={{ color: isLightTheme? "black": "white", fontWeight: 'bold' }}>0</Typography>
                    </Box>
                    <Box sx={boxStyle}>
                    <Typography sx={{ marginTop: '10px', fontSize: '12px', color: isLightTheme? "black": "white", fontWeight: 'bold' }}>
                        {t("referral.yesterdayvalidbet")}
                    </Typography>
                    <Typography sx={{ color: isLightTheme? "black": "white", fontWeight: 'bold' }}>{`${process.env.REACT_APP_CURRENCY_CODE} 0.00`}</Typography>
                    </Box>
                </Box>
                </Box>
                <Typography sx={{ color: isLightTheme ? "black" : "white" }} textAlign={"center"}>
                {t("referral.sharetofriends")}
                </Typography>
                <br />
                <Typography fontWeight="bold" color="grey" textAlign={"center"}>
                {t("referral.inviteurl")}
                </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <TextField
                // label={t("walletcard.myaccountpage.referrallink")}
                // value={shareLink}
                InputLabelProps={{shrink: true}}
                disabled
                type="text"
                size="small"
                value={shareLink?.result?.url ?? ''} 
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                disableRipple
                                sx={{
                                    "&.MuiButtonBase-root:hover": {
                                        backgroundColor: "transparent",
                                    },
                                }}
                            >
                                <CopiedTooltip text={shareLink?.result?.url ?? ''}/>
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
                sx={{width:'326px'}}
            />
            </Box>
            
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                {/* <img src="/assets/img/facebook.png" style={{ height:'40px', width:'40px', marginRight: '15px' }}/> */}
                <SocialMediaButton shareUrl={shareLink?.result?.url ?? ''} title={defaultShareMessage} />
                {/* <img src="/assets/img/telegram.png" style={{ height:'40px', width:'40px', marginRight: '15px' }}/>
                <img src="/assets/img/twitter.png" style={{ height:'40px', width:'40px', marginRight: '15px' }}/>
                <img src="/assets/img/whatsapp.png" style={{ height:'40px', width:'40px', marginRight: '15px' }}/> */}
            </div>
            </Box>
            </>
            )}
            <Typography fontWeight="bold" sx={{ color: isLightTheme ? "black" : "white" }} paddingTop={"20px"} textAlign={"center"} fontSize={"24px"}>
            {t("referral.rewardsofar")}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', margin: 1, paddingBottom:'10px'}}>
                <RewardBox
                    title={t("referral.referralbonus")}
                    baseAmount={68600}
                    basePeople={1372}
                    dailyIncrement={100} 
                    peopleIncrement={4}
                    imgSrc="/assets/img/reward_1.png"
                />
                <RewardBox
                    title={t("referral.achievementrewards")}
                    baseAmount={372079.5}
                    basePeople={290372}
                    dailyIncrement={120}
                    peopleIncrement={5}
                    imgSrc="/assets/img/reward_2.png"
                />
                <RewardBox
                    title={t("referral.achievementrewards")}
                    baseAmount={155352.99}
                    basePeople={11822}
                    dailyIncrement={80}
                    peopleIncrement={3}
                    imgSrc="/assets/img/reward_3.png"
                />
            </Box>
            <Typography fontWeight="bold" sx={{ color: isLightTheme ? "black" : "white" }} textAlign={"center"} fontSize={"24px"}>
            {t("referral.leaderboard")}
            </Typography>

            <Box
            sx={{
                background: "linear-gradient(to bottom right, #58CFFB, #9370FF)",
                borderRadius: 3,
                padding: 3,
                margin: 2,
                color: "white",
            }}
            >
            {/* Top 3 Winners */}
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "flex-end", mb: 3, gap: 2 }}>
            {/* Rank 2 - Left */}
            <Box sx={{ textAlign: "center" }}>
            <Box sx={{ position: "relative", display: "inline-block" }}>
                <Box
                component="img"
                src={referralRankings?.result?.second?.imageUrl || "/assets/img/profile_placeholder.jpg" }
                alt="Rank 2"
                onError={(e) => {
                    e.target.onerror = null; 
                    e.target.src = "/assets/img/profile_placeholder.jpg"; 
                }}
                sx={{
                    width: 56,
                    height: 56,
                    borderRadius: "50%",
                    display: "block"
                }}
                />
                <Box
                sx={{
                    width: 20,
                    height: 20,
                    borderRadius: "50%",
                    backgroundColor: "gold",
                    color: "#000",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    fontSize: "12px",
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    transform: "translate(30%, 30%)", // Push it outside for visual effect
                }}
                >
                2
                </Box>
            </Box>
            <Typography fontSize={"10px"} fontWeight="bold">{referralRankings?.result?.second?.name}</Typography>
            <Typography fontSize={"10px"}>{process.env.REACT_APP_CURRENCY_CODE} {referralRankings?.result?.second?.amount || 76815.55}</Typography>
            </Box>


            {/* Rank 1 - Middle, higher */}
            <Box sx={{ textAlign: "center" }}>
            <Box sx={{ position: "relative", display: "inline-block", mb: 2 }}>
                <Box
                component="img"
                src={referralRankings?.result?.first?.imageUrl || "/assets/img/profile_placeholder.jpg"}
                onError={(e) => {
                    e.target.onerror = null; 
                    e.target.src = "/assets/img/profile_placeholder.jpg"; 
                }}
                alt="Rank 1"
                sx={{ width: 88, height: 88, borderRadius: "50%" }}
                />
                <Box
                sx={{
                    width: 30,
                    height: 30,
                    borderRadius: "50%",
                    backgroundColor: "gold",
                    color: "#000",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    fontSize: "14px",
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    transform: "translate(20%, 20%)", // Adjusts slightly up/left from corner
                }}
                >
                1
                </Box>
            </Box>
            <Typography fontSize={"12px"} fontWeight="bold" mt={-2} mb={1}>
                {referralRankings?.result?.first?.name}
            </Typography>
            <Typography fontSize={"12px"} mt={-0.5}>
                {process.env.REACT_APP_CURRENCY_CODE} {referralRankings?.result?.first?.amount || 146815.55}
            </Typography>
            </Box>

            {/* Rank 3 - Right */}
            <Box sx={{ textAlign: "center" }}>
            <Box sx={{ position: "relative", display: "inline-block" }}>
                <Box
                component="img"
                src={referralRankings?.result?.third?.imageUrl || "/assets/img/profile_placeholder.jpg"}
                onError={(e) => {
                    e.target.onerror = null; 
                    e.target.src = "/assets/img/profile_placeholder.jpg"; 
                }}
                alt="Rank 2"
                sx={{
                    width: 56,
                    height: 56,
                    borderRadius: "50%",
                    display: "block"
                }}
                />
                <Box
                sx={{
                    width: 20,
                    height: 20,
                    borderRadius: "50%",
                    backgroundColor: "gold",
                    color: "#000",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "bold",
                    fontSize: "12px",
                    position: "absolute",
                    bottom: 0,
                    right: 0,
                    transform: "translate(30%, 30%)", // Push it outside for visual effect
                }}
                >
                2
                </Box>
            </Box>
            <Typography fontSize={"10px"} fontWeight="bold">{referralRankings?.result?.third?.name}</Typography>
            <Typography fontSize={"10px"}>{process.env.REACT_APP_CURRENCY_CODE} {referralRankings?.result?.third?.amount || 46815.55}</Typography>
            </Box>
            </Box>


            {/* Reward List */}
            <Typography fontWeight="bold" fontSize={"20px"} textAlign="center" mb={2}>
                {t("referral.whoreceived")}
            </Typography>

            <AnimatePresence mode="wait">
                {rewardList}
            </AnimatePresence>
            </Box>
            <Box sx={{ mt: 4, pb: 15 }}>
            <Box sx={{ p: 2, textAlign: 'center', backgroundColor: '#f5f5f5', borderRadius: 2, }}>
            <Typography fontWeight="bold" fontSize="18px" mb={1}>
                {t("referral.rewardestimator")}
            </Typography>         
            <Typography mt={2} fontSize="16px" fontWeight="bold">
                {process.env.REACT_APP_CURRENCY_CODE} {(inviteCount * process.env.REACT_APP_REFERRAL_VALUE).toLocaleString(undefined, { minimumFractionDigits: 2 })} {t("referral.amount")}
            </Typography>
            <Typography fontSize="14px">
                {t("referral.inviteUsers", { count: inviteCount })}
            </Typography>
            <Slider
                value={inviteCount}
                onChange={(e, val) => setInviteCount(val)}
                min={1}
                max={100}
                step={1}
                valueLabelDisplay="auto"
                sx={{ maxWidth: 300, mx: 'auto' }}
            />
            </Box>
            </Box>
            </Box>
             </>
          ) : (
            <Box sx={{ padding: 2 }}>
              {sections[selectedTab].component ? (
                sections[selectedTab].component
              ) : (
                <AccordionComponent selectedSection={sections[selectedTab].id} />
              )}
            </Box>
          )}
        </Box>
      </Box>
   
  </Container>
);
};
export default Referral;
